<template>
    <vue-modal id="digitalReservationStartModal" classes="vue-modal-container" height="auto"
        name="digital-external-url-modal" scrollable @before-open="beforeModalOpen" @closed="onClose">

      <button class="close-modal"
              @click="$modal.hide('digital-external-url-modal')">
        <i class="close icon"/>
      </button>        
        <div class="xyz-content">
                <h3>Fizetés feldolgozás alatt <br/>
            Kövesse a terminál utasításait</h3>

            <lottie-animation :width="300" path="static/img/fp-pos-loading.json" />
            <div v-if="error" class="xyz-error">{{ error.message || "HIBA A FIZETÉS KÖZBEN" }}</div>
            <button class="ui primary button small" @click="onRetry()">Újra</button>
        </div>
        
    </vue-modal>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex'
import config from './../../config';
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs

export default {
    components: { LottieAnimation },
    data() {
        return {
            //isRocket: true,
        }
    },
    computed: {
        pending() { return this.$store.state.digitalPOSPending; },
        error() { return this.$store.state.digitalPOSLastError; },
        showRetry() { return !!this.error && !!this.pending; },
        ...mapState({
            trans: state => state.trans.digitalReservationStartModal,
        }),
    },

    watch: {
        // Whenever a new request arrives, attempt it
        pending: {
            immediate: true,
            handler(p) {
                if (!p) return;
                this.attemptLaunch(p);
            }
        },
        /*showRetry(v) {
            v ? this.$modal.show("digital-external-url-modal") : this.$modal.show("digital-external-url-modal");
        }*/
    },

    methods: {
        beforeModalOpen(event) {
            if (event?.params?.initialState) {
                this.step = event.params.initialState
            }
        },

        async attemptLaunch(p) {
            // 1) fire-and-forget log BEFORE leaving page (best effort)
            this.logToServer({ type: "launch_attempt", ...p });

            // 2) attempt navigation
            const ok = this.tryNavigate(p.url);

            if (!ok) {
                // blocked or failed immediately
                await this.logToServer({ type: "launch_failed_immediate", ...p, reason: "blocked_or_invalid" });
                this.$store.dispatch("digitalPOSMarkFailed", { message: "Browser blocked the redirect. Please retry.", code: "BLOCKED" });
                return;
            }

            // 3) If navigation actually happens, page will unload. If it doesn't (some platforms),
            // set a short watchdog and if we're still here, treat as failure.
            setTimeout(async () => {
                // If still on same page, assume it didn't work
                // (Not perfect, but catches many “nothing happened” cases.)
                await this.logToServer({ type: "launch_watchdog_timeout", ...p });
                this.$store.dispatch("digitalPOSMarkFailed", { message: "Redirect didn’t start. Please retry.", code: "TIMEOUT" });
            }, 3000);
        },

        tryNavigate(url) {
            try {
                // Basic sanity check
                if (!url || typeof url !== "string") return false;

                // If you’re launching custom schemes like sumupmerchant://,
                // prefer location.assign (same as href but clearer intent)
                window.location.assign(url);

                // If assign throws (rare), catch below. Usually it won’t throw even if blocked,
                // so we also rely on watchdog timeout.
                return true;
            } catch (e) {
                return false;
            }
        },

        async logToServer(payload) {
            try {
                // BEST for “page may unload”: sendBeacon

                const logUrl = config.SERVER_DOMAIN + '/api/global/clientlog';
                const data = {
                    //...this.$store.getters.getAuthParams,
                    ...payload,
                };
                console.log('_-----------.............--------------------');
                console.log(data);
                /*if (navigator.sendBeacon) {
                    const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
                    navigator.sendBeacon(logUrl, blob);
                    return Promise.resolve();
                }*/


                await Vue.http({
                    url: logUrl,
                    method: 'POST',
                    params: this.$store.getters.getAuthParams,
                    body: {
                        data
                    }

                }).then(() => { });
            } catch {
                return Promise.resolve();
            }
        },

        onRetry() {
            // Clear error first if you want, or leave it
            this.$store.dispatch("digitalPOSRetry");
        },
        onClose() {
            this.$store.dispatch("digitalPOSMarkFailed",  { message: "User clicked the close button.", code: "CANCEL" });
            this.$store.commit("DIGITAL_POS_CLEAR");
            this.$modal.hide('digital-reservation-start-modal');
            this.$modal.hide('digital-external-url-modal'); 
        }
    }
};
</script>
<style>
.xyz-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1em;
}

.xyz-error {
    color: red;
    padding: 1em 0;
}
</style>